import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const ReturningUserBanner = () => {
    const isBannerEnabled = checkFeatureFlagGate(
        featureFlags.jiraProductTourReturningUserBanner
    );
    if (!isBannerEnabled) {
        return null;
    }
    return (
        <div css={bannerCss} data-testid="returning-user-banner">
            <span>📣</span>
            <FormattedMessage
                id="JiraProductTourReturningUserBanner.message"
                defaultMessage="Introducing agents in Jira <link>Learn more</link>"
                values={{
                    link: LearnMoreLink
                }}
            />
        </div>
    );
};

const LearnMoreLink = (chunks: React.ReactNode) => (
    <a
        href="https://www.atlassian.com/blog/announcements/ai-agents-in-jira"
        css={linkCss}
    >
        {chunks}
    </a>
);

const bannerCss = css({
    alignItems: "center",
    backgroundColor: wacToken("color.extended.blue200"),
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    justifyContent: "center",
    lineHeight: 1.25,
    padding: "1rem"
});

const linkCss = css({
    color: wacToken("color.extended.blue700"),
    textDecoration: "none",
    [":hover"]: {
        textDecoration: "underline"
    }
});
